export const entorno = {
  production: true,
  devLocal: false,
  tenant: "72fd0b5a-8a6a-4cff-89f6-bde961f7e250",
  clientId: "ffd94216-3b73-485b-9fc7-da10a95f505f",
  redirectUri: "https://calificaciones.duoc.cl/callback",
  endpointDocente: "https://calificaciones-servicios-docentes.duoc.cl/api",
  endpointAdministrativo: "https://calificaciones-servicios-administrativos.duoc.cl/api",
  endpointIntegracion: "https://calificaciones-servicios-integracion.duoc.cl/api",
  appInsights: "f1c69234-aecc-4970-8804-c6d8549a0e18",
  tiempoSocketEstadoAlumnos: 15,
  tiempoReconexionSocket: 10
};
